<template>
  <div class="session-speaker-container" :class="containerClasses">
    <profile-picture :initials="initials" :picture="picture" class="session-speaker-avatar is-28x28"></profile-picture>
    <div class="session-speaker-full-name">
      {{ fullName }}
    </div>
  </div>
</template>

<script>
import ProfilePicture from "@/shared/components/common/profile/ProfilePicture";
import { initials, fullName } from "@/shared/utils";

export default {
  name: "AgendaSessionSpeakerListItem",

  components: { ProfilePicture },

  props: {
    speaker: {
      type: Object,
      required: true,
    },

    isSearchResult: {
      type: Boolean,
      required: true,
    }
  },

  computed: {
    fullName() {
      return fullName(this.speaker);
    },

    initials() {
      return initials(this.speaker);
    },

    picture() {
      return this.speaker.picture;
    },

    containerClasses() {
      if(this.isSearchResult) {
        return "is-search-result";
      } else {
        return "";
      }
    }
  },
};
</script>

<style scoped lang="scss">
.session-speaker-container {
  border-radius: 20px;
  height: 42px;
  padding: 0 12px 0 6px;
  display: flex;
  flex-direction: row;
  align-items: center;
  background: var(--agenda-speaker-capsule-background);
  box-shadow: -1px 0px 0px 0px var(--agenda-speaker-capsule-shadow), 1px 0px 0px 0px var(--agenda-speaker-capsule-shadow), 0px 1px 0px 0px var(--agenda-speaker-capsule-shadow), 0px 0px 0px 1px var(--agenda-speaker-capsule-shadow);

  &.is-search-result {
    background: var(--primary-color-focus);
    box-shadow: none;
  }
}

.session-speaker-full-name {
  font-size: 16px;
  line-height: 130%;
  font-weight: var(--global-title-text-weight);
  margin-left: 8px;
  color: var(--agenda-speaker-capsule-text);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.session-speaker-avatar {
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  font-size: 12px;
}
</style>
